<template>
  <base-card class="mb-4">
    <base-text
      size="s"
      medium
      class="title-card mb-3"
    >
      Data Date Range
    </base-text>
    <div class="row no-gutters">
      <div
        v-for="(period, index) in validPeriods"
        :key="`period_${index}`"
        class="col-3 periodtab text-center my-0"
        @click="selectPeriod(index)"
      >
        <base-text
          inline
          size="m"
          :class="`text-center periodtext ${current === index ? 'selected': 'not-selected'}`"
        >
          {{ period.name }}
        </base-text>
        <hr style="margin: 0;">
      </div>
    </div>
  </base-card>
</template>
<script>

/*
    XXX keep same as a 'ranges' list defined in full_report() at
    <stylelab-backend>/api/management/commands/report.py:306
 */
export const ranges = ['today', 'week', 'mtd', 'ytd'];
export const [TODAY, WEEK, MONTH, YEAR] = ranges;

export default {
  name: 'DataRangeSelector',
  props: {
    value: {
      type: String,
      default: TODAY,
      validator: (s) => ranges.includes(s),
    },
  },
  data() {
    return {
      validPeriods: [{
        name: 'Today',
        filter: TODAY,
      }, {
        name: 'This Week',
        filter: WEEK,
      }, {
        name: 'Month-to-date',
        filter: MONTH,
      }, {
        name: 'Year-to-date',
        filter: YEAR,
      }],
    };
  },
  computed: {
    current() {
      return this.validPeriods.findIndex((period) => period.filter === this.value);
    },
  },
  methods: {
    selectPeriod(index) {
      if (this.validPeriods[index].filter === TODAY) {
        if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
          this.$mixpanel.track('Select_Today', {
            location: '/reports',
            Select: this.validPeriods[index].name,
            account_id: this.$store.state.account.user.user.email,
          });
        }
      } else if (this.validPeriods[index].filter === WEEK) {
        if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
          this.$mixpanel.track('Select_This_Week', {
            location: '/reports',
            Select: this.validPeriods[index].name,
            account_id: this.$store.state.account.user.user.email,
          });
        }
      } else if (this.validPeriods[index].filter === MONTH) {
        if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
          this.$mixpanel.track('Select_Month-to-Date', {
            location: '/reports',
            Select: this.validPeriods[index].name,
            account_id: this.$store.state.account.user.user.email,
          });
        }
      } else if (this.validPeriods[index].filter === YEAR) {
        if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
          this.$mixpanel.track('Select_Year-to-Date', {
            location: '/reports',
            Select: this.validPeriods[index].name,
            account_id: this.$store.state.account.user.user.email,
          });
        }
      }
      this.$emit('input', this.validPeriods[index].filter);
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('range_clicked', {
          location: '/admin/reports',
          range: this.validPeriods[index].name,
          account_id: this.$store.state.account.user.user.email,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.periodtab {
  transition: background-color 0.3s ease;
  cursor: pointer;
  padding-top: 15px;
  .periodtext {
    padding-bottom: 8px;
    display: inline-block;
    line-height: 1;
    border-bottom: 3px transparent solid;
    transition: all 0.2s;
  }
  &:hover .periodtext {
    border-bottom-color: #EEE;
  }
}

.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
}

.selected {
  font-family: 'SilkaMedium';
  border-bottom-color: $clementine !important;
}
.not-selected {
  font-family: 'SilkaMedium';
  color: #909090;
}
</style>
